import { useCallback, useState } from 'react'

export const usePartnerActions = () => {
  const [showSelectPartnerModal, setShowSelectPartnerModal] = useState(false)

  const openPartnerSelectModal = useCallback(() => {
    setShowSelectPartnerModal(true)
  }, [])

  const closePartnerSelectModal = useCallback(() => {
    setShowSelectPartnerModal(false)
  }, [])

  return {
    showSelectPartnerModal,
    closePartnerSelectModal,
    openPartnerSelectModal,
    setShowSelectPartnerModal,
  }
}
